(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-reels"] && !Shopify.designMode) return;
  try {
    /* Delegated on document rather than bound at parse time: inline block
   scripts run before assets/main.js, and Section Rendering API updates in
   the theme editor can replace this markup without a full page reload. */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;

  var prev = t.closest('[data-reels-prev]');
  var next = t.closest('[data-reels-next]');
  if (!prev && !next) return;

  var reelsRoot = (prev || next).closest('.pdp-reels');
var viewport = reelsRoot && reelsRoot.querySelector('[data-reels-viewport]');
  if (!viewport) return;

  var pitch = parseFloat(viewport.dataset.reelsPitch) || 0;
  if (!pitch) return;

  /* Hand-rolled ease instead of scrollBy smooth: in this page's Chrome
     the native smooth animation on this container is cancelled on the
     same tick it starts (instant scrolls work, smooth lands back on the
     starting position). rAF is immune to whatever cancels it. */
  var from = viewport.scrollLeft;
  var to = Math.max(0, Math.min(viewport.scrollWidth - viewport.clientWidth,
    from + (prev ? -pitch : pitch)));
  var t0 = null;
  var DUR = 280;
  viewport.__animating = true;
  function step(ts) {
    if (t0 === null) t0 = ts;
    var k = Math.min(1, (ts - t0) / DUR);
    var e = 1 - Math.pow(1 - k, 3);
    viewport.scrollLeft = from + (to - from) * e;
    if (k < 1) { requestAnimationFrame(step); }
    else { viewport.__animating = false; reelsWrap(viewport); }
  }
  requestAnimationFrame(step);
});

/* Fullscreen stories player. Static JS: every per-reel value arrives on
   the tile's data attributes, and add-to-cart goes through the theme's
   Shop Now link on the card. Delegated on document, the convention
   everywhere on this PDP. */
var reelsPlayer = null;
var reelsList = [];
var reelsIndex = 0;

function reelsEnsurePlayer() {
  if (reelsPlayer) return reelsPlayer;
  var tpl = document.querySelector('template[data-reels-player-template]');
  if (!tpl) return null;
  reelsPlayer = tpl.content.firstElementChild.cloneNode(true);
  document.body.appendChild(reelsPlayer);
  reelsPlayer.style.display = 'none';
  return reelsPlayer;
}

function reelsRead(tile) {
  var d = tile.dataset;
  var strip = tile.closest('.pdp-reels');
  var f = strip ? strip.dataset : {};
  return { video: d.videoSrc || '', embed: d.embedSrc || '', poster: d.poster || '',
    label: d.label || '',
    pTitle: d.pTitle || f.fbPTitle || '', pPrice: d.pPrice || f.fbPPrice || '',
    pImg: d.pImg || f.fbPImg || '', pUrl: d.pUrl || f.fbPUrl || '',
    variant: d.variant || f.fbVariant || '' };
}

function reelsRender() {
  var p = reelsPlayer, item = reelsList[reelsIndex];
  if (!p || !item) return;
  var frame = p.querySelector('[data-reelsp-frame]');
  frame.innerHTML = '';
  var mute = p.querySelector('[data-reelsp-mute]');
  if (item.video) {
    var v = document.createElement('video');
    v.src = item.video;
    if (item.poster) v.poster = item.poster;
    v.autoplay = true; v.muted = !mute.classList.contains('is-sound');
    v.playsInline = true; v.setAttribute('playsinline', '');
    if (item.label) v.setAttribute('aria-label', item.label);
    v.addEventListener('timeupdate', function () {
      var bar = p.querySelectorAll('[data-reelsp-progress] span i')[reelsIndex];
      if (bar && v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
    });
    v.addEventListener('ended', function () {
      if (reelsIndex < reelsList.length - 1) reelsGo(reelsIndex + 1);
    });
    frame.appendChild(v);
    mute.style.display = '';
  } else if (item.embed) {
    var f = document.createElement('iframe');
    f.src = item.embed;
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.setAttribute('allowfullscreen', '');
    if (item.label) f.title = item.label;
    frame.appendChild(f);
    mute.style.display = 'none';
  }
  var segs = p.querySelectorAll('[data-reelsp-progress] span');
  segs.forEach(function (sEl, i) {
    sEl.classList.toggle('is-done', i < reelsIndex);
    var bar = sEl.querySelector('i');
    if (bar && i !== reelsIndex) bar.style.transform = i < reelsIndex ? 'scaleX(1)' : 'scaleX(0)';
    if (bar && i === reelsIndex && !item.video) bar.style.transform = 'scaleX(1)';
    if (bar && i === reelsIndex && item.video) bar.style.transform = 'scaleX(0)';
  });
  var prev = p.querySelector('[data-reelsp-prev]');
  var next = p.querySelector('[data-reelsp-next]');
  if (prev) prev.disabled = reelsIndex === 0;
  if (next) next.disabled = reelsIndex === reelsList.length - 1;
  var card = p.querySelector('[data-reelsp-product]');
  if (item.pTitle) {
    card.hidden = false;
    card.querySelector('[data-reelsp-p-title]').textContent = item.pTitle;
    card.querySelector('[data-reelsp-p-price]').textContent = item.pPrice;
    var link = card.querySelector('[data-reelsp-p-link]');
    link.href = item.pUrl || '#';
    var img = card.querySelector('[data-reelsp-p-img]');
    if (item.pImg) { img.src = item.pImg; img.hidden = false; } else img.hidden = true;
    var shop = card.querySelector('[data-reelsp-shop]');
    shop.href = item.pUrl || '#';
    shop.hidden = !item.pUrl;
  } else card.hidden = true;
}

function reelsGo(i) { reelsIndex = Math.max(0, Math.min(reelsList.length - 1, i)); reelsRender(); }

function reelsOpen(tile) {
  var strip = tile.closest('.pdp-reels');
  if (!strip || !reelsEnsurePlayer()) return;
  var tiles = Array.prototype.slice.call(
    strip.querySelectorAll('[data-reel-open]:not([data-reel-clone])'));
  reelsList = tiles.map(reelsRead);
  reelsIndex = tile.dataset.reelIndex
    ? Number(tile.dataset.reelIndex)
    : Math.max(0, tiles.indexOf(tile));
  var prog = reelsPlayer.querySelector('[data-reelsp-progress]');
  prog.innerHTML = reelsList.map(function () { return '<span><i></i></span>'; }).join('');
  reelsPlayer.style.display = '';
  document.body.classList.add('reelsp-open');
  reelsRender();
  var closeBtn = reelsPlayer.querySelector('.reelsp__close');
  if (closeBtn) closeBtn.focus();
}

function reelsClose() {
  if (!reelsPlayer) return;
  var frame = reelsPlayer.querySelector('[data-reelsp-frame]');
  if (frame) frame.innerHTML = '';
  reelsPlayer.style.display = 'none';
  document.body.classList.remove('reelsp-open');
}

document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;
  var openTile = t.closest('[data-reel-open]');
  if (openTile) { e.preventDefault(); reelsOpen(openTile); return; }
  if (t.closest('[data-reelsp-close]')) { reelsClose(); return; }
  if (t.closest('[data-reelsp-prev]')) { reelsGo(reelsIndex - 1); return; }
  if (t.closest('[data-reelsp-next]')) { reelsGo(reelsIndex + 1); return; }
  var mute = t.closest('[data-reelsp-mute]');
  if (mute) {
    mute.classList.toggle('is-sound');
    var vid = reelsPlayer && reelsPlayer.querySelector('video');
    if (vid) vid.muted = !mute.classList.contains('is-sound');
    return;
  }
});

document.addEventListener('keydown', function (e) {
  if (!reelsPlayer || reelsPlayer.style.display === 'none') return;
  if (e.key === 'Escape') reelsClose();
  if (e.key === 'ArrowRight') reelsGo(reelsIndex + 1);
  if (e.key === 'ArrowLeft') reelsGo(reelsIndex - 1);
});

var reelsTouchX = null;
document.addEventListener('touchstart', function (e) {
  if (reelsPlayer && reelsPlayer.style.display !== 'none') reelsTouchX = e.touches[0].clientX;
}, { passive: true });
document.addEventListener('touchend', function (e) {
  if (reelsTouchX === null || !reelsPlayer || reelsPlayer.style.display === 'none') return;
  var dx = e.changedTouches[0].clientX - reelsTouchX;
  reelsTouchX = null;
  if (dx < -40) reelsGo(reelsIndex + 1);
  if (dx > 40) reelsGo(reelsIndex - 1);
}, { passive: true });

/* Infinite loop. The tile set is duplicated once and the viewport jumps
   by exactly one set width at the boundaries; both frames are pixel
   identical, so the jump is invisible. Clones carry data-reel-clone plus
   the original index, and the player playlist skips them, so opening a
   cloned tile plays the original list at the right position. Jumps are
   suppressed while the arrow's rAF animation runs, then applied once at
   the end, otherwise the correction and the animation fight. */
function reelsSetupLoop(strip) {
  var vp = strip.querySelector('[data-reels-viewport]');
  var track = strip.querySelector('[data-reels-track]');
  if (!vp || !track || vp.dataset.looped) return;
  var originals = Array.prototype.slice.call(track.children)
    .filter(function (c) { return c.querySelector && c.querySelector('.pdp-reels__tile'); });
  if (originals.length < 2) return;
  vp.dataset.looped = '1';
  originals.forEach(function (child, i) {
    var tile = child.querySelector('[data-reel-open]');
    if (tile) tile.dataset.reelIndex = i;
    var clone = child.cloneNode(true);
    clone.querySelectorAll('[data-reel-open]').forEach(function (ct) {
      ct.setAttribute('data-reel-clone', '');
      ct.dataset.reelIndex = i;
    });
    clone.querySelectorAll('video').forEach(function (v) { v.muted = true; });
    track.appendChild(clone);
  });
  requestAnimationFrame(function () {
    vp.__setW = track.scrollWidth / 2;
  });
  vp.addEventListener('scroll', function () {
    if (vp.__animating || !vp.__setW) return;
    reelsWrap(vp);
  }, { passive: true });
}
function reelsWrap(vp) {
  var setW = vp.__setW;
  if (!setW) return;
  if (vp.scrollLeft > setW + 1) vp.scrollLeft -= setW;
  else if (vp.scrollLeft < 1) vp.scrollLeft += setW;
}
document.querySelectorAll('.pdp-reels[data-reels-infinite]').forEach(reelsSetupLoop);
  } catch(e) { console.error(e); }
})();

})();
